/**
 * KundenfreigabeKanalDialog — E14 «Kanal wechseln» (P2 Placement Slice 12, Tab 4c). The other channel
 * is preselected; a Grund (>= 3 chars) is required; the document is re-delivered over the new channel.
 */

import { useState } from 'react';
import { KUNDENFREIGABE_GRUND_MIN, type CustomerDeliveryChannel, type KundenfreigabeKanalBody, type KundenfreigabeResponse } from '@brokly/shared';
import { Dialog } from '../administration/components';
import { Button } from '../../components/ui/Button';

export function KundenfreigabeKanalDialog({
  open,
  onClose,
  current,
  facts,
  onWechseln,
  saving,
  error,
}: {
  open: boolean;
  onClose: () => void;
  current: CustomerDeliveryChannel;
  facts: KundenfreigabeResponse;
  onWechseln: (body: KundenfreigabeKanalBody) => void;
  saving: boolean;
  error: { code?: string } | null;
}) {
  const other: CustomerDeliveryChannel = current === 'portal' ? 'email' : 'portal';
  const [grund, setGrund] = useState('');
  const canSubmit = grund.trim().length >= KUNDENFREIGABE_GRUND_MIN && !saving;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Kanal wechseln"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose}>Abbrechen</Button>
          <Button disabled={!canSubmit} onClick={() => onWechseln({ channel: other, grund: grund.trim() })} data-testid="kundenfreigabe-kanal-submit">
            Kanal wechseln und erneut zustellen
          </Button>
        </div>
      }
    >
      <div className="space-y-3 text-sm" data-testid="kundenfreigabe-kanal-dialog">
        <p>
          Neuer Kanal: <strong>{other === 'portal' ? 'Kundenportal' : `E-Mail an ${facts.kunde_email ?? '-'}`}</strong>
        </p>
        <label className="block">
          <span className="text-xs text-muted-foreground">Grund</span>
          <textarea
            className="mt-1 w-full rounded-md border border-border p-2"
            value={grund}
            onChange={(e) => setGrund(e.target.value)}
            data-testid="kf-kanal-grund"
          />
        </label>
        <p className="text-xs text-muted-foreground">Das Vergleichsdokument wird ueber den neuen Kanal erneut zugestellt (E14).</p>
        {error?.code && <p className="text-sm text-red-600">Kanalwechsel fehlgeschlagen ({error.code})</p>}
      </div>
    </Dialog>
  );
}
